import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Autorizacion} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiAutService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** autorizaciones ***/

  getAutorizaciones(): Promise<[Autorizacion[], Autorizacion[]]> {
    const url = `${this.apiUrl}autorizaciones`;
    return firstValueFrom(this.http.get<[Autorizacion[], Autorizacion[]]>(url))
  }
  getAutorizacion(id: number): Promise<Autorizacion> {
    const url = `${this.apiUrl}autorizaciones/${id}`;
    return firstValueFrom(this.http.get<Autorizacion>(url))
  }
  guardarAutorizacion(datos: Autorizacion): Promise<any> {
    const url = `${this.apiUrl}autorizaciones`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  eliminarAutorizacion(id: number): Promise<any> {
    const url = `${this.apiUrl}autorizaciones/${id}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
